"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./radio.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  The Radio buttons require you to use Redux-From
*/

/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
// See: https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/51
var Radio = function Radio(props) {
  var input = _objectSpread(_objectSpread({}, props.input), {}, {
    disabled: props.disabled
  });

  var classes = (0, _classnames["default"])('Radio', input.name, props.className, {
    disabled: input.disabled
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "radio"
  }, input)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "circle"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "selected"
  })), props.label));
};

Radio.propTypes = {
  label: _propTypes["default"].node,
  input: _propTypes["default"].object,
  // eslint-disable-line
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
Radio.defaultProps = {
  label: '',
  className: '',
  disabled: false
};
var _default = Radio;
exports["default"] = _default;